import { useEffect, useMemo, useRef, useState } from "react";
import { usePlayerEconomy } from "../src/stores/usePlayerEconomy";
import { useInteractionStore } from "../src/stores/useInteraction";
import { usePlayerHealth } from "../src/stores/usePlayerHealth";

const CALACA_CAPTIONS = {
  1: "A VECES PIENSO... LUEGO SE ME OLVIDA",
  2: "HOY NO SE FÍA, MAÑANA TAMPOCO",
  3: "ORGULLOSAMENTE DEUDOR DE COPPEL",
  4: "DIOS PERDONA, EL SAT NO",
  5: "DIGANLE AL PROFE QUE NO ME PONGA FALTA, YA MERO LLEGO",
  6: "MI DEBILIDAD SON LAS CAJERAS DEL OXXO",
  7: "SI TUS NALGAS FUERAN EL MAR, YO SERÍA MOISÉS",
  8: "¡GORDAS Y FEAS ALEJENSE!",
  9: "ADICTO A LAS MAMÁS SOLTERAS",
  10: "SÁLVAME SAN JUDITAS DEL MAL DE AMORES",
  11: "QUITENSE, ME VOY CAGANDO",
  12: "JSJSJSJS AL CHILE XD",
  13: "¿Y SI ME MUERO... QUIÉN PAGA EL INTERNET?",
  14: "CAEN LAS BECAS, CAEN LA VIEJAS",
  15: "ADICTO A LAS SIN AFECTO PERSONAL",
  16: "LA CERVEZA FRÍA, LAS MUJERES CALIENTES",
  17: "¿YA ES VIERNES DE AHORCAR RUCAS?",
  18: "ENVIANDO SEÑALES CONFUSAS DESDE 1993",
  19: "¡HUEHOS! AHÍ TE VA UN +4 QLERO",
  20: "QUITENLE SU INE, EL PENDEJO QUIERE VOTAR POR XÓCHITL",
  21: "ADICTO AL CALCIO Y AL CHISME",
  22: "¡QUE CHINGUE A SU MADRE EL CUMPLAÑERO!",
  23: "HAZTE A UN LADO CARNAL, YA EMPEZÓ LA GUERRA FRIA. LE VOY A DISPARAR AL REFRI",
  24: "LO SIENTO CARNAL, TUS GFES NO ESTÁN DIVORCIADOS. NO ESTÁS A LA MODA",
  25: "UN VERDADERO HOMBRE NUNCA HABLA MAL DE LÓPEZ OBRADOR",
  26: "PURO PINCHE CLAUDIA SHEINBAUM, PURA 4T ALV",
  27: "YO DECLARO QUE NO LE SABES A LAS CALACAS",
  28: "JAJAJA QUE PINCHE MIADOTA ME ECHÉ EN LA ALBERCA",
  29: "CANSADO DE SER UN ESPECTADOR",
  30: "NO FUE MI CULPA, FUE EL HORÓSCOPO",
  31: "PENSANDO SERIAMENTE EN DEJAR DE PENSAR",
  32: "MODO AVIÓN (ETERNO)",
  33: "EL FUTURO ES HOY, ¿O ERA AYER?",
};

const COIN_ICON_PATH = "M12 2C6.48 2 2 4.69 2 8v8c0 3.31 4.48 6 10 6s10-2.69 10-6V8c0-3.31-4.48-6-10-6zm8 6c0 2.21-3.58 4-8 4S4 10.21 4 8s3.58-4 8-4 8 1.79 8 4zm0 4.09c0 2.21-3.58 4-8 4s-8-1.79-8-4V10c1.8 1.52 4.9 2.46 8 2.46s6.2-.94 8-2.46v2.09zm0 4c0 2.21-3.58 4-8 4s-8-1.79-8-4v-1.97c1.84 1.4 4.92 2.24 8 2.24s6.16-.84 8-2.24V16.09z";

const SHOP_ITEMS = [
  { id: "refresco", name: "Refresco", price: 5, heal: 1 },
  { id: "taco", name: "Taco", price: 10, heal: 2 },
  { id: "cemita", name: "Cemita", price: 15, heal: 3 },
];

const STATUS_DURATION = 2200;

export default function SkeletonShop() {
  const shopVisible = useInteractionStore((state) => state.shopVisible);
  const hideShop = useInteractionStore((state) => state.hideShop);
  const coins = usePlayerEconomy((state) => state.coins);
  const spendCoins = usePlayerEconomy((state) => state.spendCoins);
  const restoreHearts = usePlayerHealth((state) => state.restoreHearts);

  const formattedCoins = useMemo(() => coins.toLocaleString(), [coins]);
  const [calacaImage, setCalacaImage] = useState(null);

  const [feedback, setFeedback] = useState(null);
  const feedbackTimeoutRef = useRef(null);
  const [coinDiff, setCoinDiff] = useState(null);
  const coinDiffTimeoutRef = useRef(null);
  const previousCursorRef = useRef(null);

  useEffect(() => {
    if (!shopVisible) {
      if (feedbackTimeoutRef.current !== null) {
        window.clearTimeout(feedbackTimeoutRef.current);
        feedbackTimeoutRef.current = null;
      }
      setFeedback(null);
      setCalacaImage(null);
      if (coinDiffTimeoutRef.current !== null) {
        window.clearTimeout(coinDiffTimeoutRef.current);
        coinDiffTimeoutRef.current = null;
      }
      setCoinDiff(null);
      if (previousCursorRef.current !== null && typeof document !== "undefined") {
        document.body.style.cursor = previousCursorRef.current;
        previousCursorRef.current = null;
      }
      return undefined;
    }

    const availableCalacas = Array.from({ length: 33 }, (_, index) => {
      const number = index + 1;
      return {
        src: `/img/calacas/${String(number).padStart(3, "0")}.gif`,
        caption: CALACA_CAPTIONS[number] ?? "Milaneso improvisa esta calaca.",
      };
    });

    const randomCalaca = availableCalacas[Math.floor(Math.random() * availableCalacas.length)] ?? null;
    setCalacaImage(randomCalaca);

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        hideShop();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    if (typeof document !== "undefined") {
      previousCursorRef.current = document.body.style.cursor;
      document.body.style.cursor = "auto";
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      if (feedbackTimeoutRef.current !== null) {
        window.clearTimeout(feedbackTimeoutRef.current);
        feedbackTimeoutRef.current = null;
      }
      if (coinDiffTimeoutRef.current !== null) {
        window.clearTimeout(coinDiffTimeoutRef.current);
        coinDiffTimeoutRef.current = null;
      }
      setCoinDiff(null);
      if (previousCursorRef.current !== null && typeof document !== "undefined") {
        document.body.style.cursor = previousCursorRef.current;
        previousCursorRef.current = null;
      }
    };
  }, [shopVisible, hideShop]);

  useEffect(() => {
    if (!feedback) return undefined;

    feedbackTimeoutRef.current = window.setTimeout(() => {
      setFeedback(null);
      feedbackTimeoutRef.current = null;
    }, STATUS_DURATION);

    return () => {
      if (feedbackTimeoutRef.current !== null) {
        window.clearTimeout(feedbackTimeoutRef.current);
        feedbackTimeoutRef.current = null;
      }
    };
  }, [feedback]);

  useEffect(() => {
    if (!coinDiff) return undefined;

    coinDiffTimeoutRef.current = window.setTimeout(() => {
      setCoinDiff(null);
      coinDiffTimeoutRef.current = null;
    }, STATUS_DURATION);

    return () => {
      if (coinDiffTimeoutRef.current !== null) {
        window.clearTimeout(coinDiffTimeoutRef.current);
        coinDiffTimeoutRef.current = null;
      }
    };
  }, [coinDiff]);

  const handlePurchase = (item) => {
    const success = spendCoins(item.price, "purchase");
    if (success) {
      const healAmount = Number(item.heal) || 0;
      if (healAmount > 0) {
        restoreHearts(healAmount);
      }

      const heartWord = healAmount === 1 ? "corazón" : "corazones";
      const healSuffix = healAmount > 0 ? ` +${healAmount} ${heartWord}` : "";

      setFeedback({ type: "success", message: `Compraste un ${item.name}!${healSuffix}`, healAmount });
      setCoinDiff({ amount: item.price, key: Date.now() });
    } else {
      setFeedback({ type: "error", message: "No tienes suficientes monedas.", healAmount: 0 });
      setCoinDiff(null);
    }
  };

  if (!shopVisible) {
    return null;
  }

  return (
    <div className="shop-overlay" role="dialog" aria-modal="true" aria-labelledby="shop-title">
      <div className="shop-panel">
        <div className="shop-panel__content">
          <div className="shop-panel__main">
            <header className="shop-panel__header">
              <div
                className="shop-panel__wallet"
                aria-live="polite"
                aria-label={`Monedas disponibles: ${formattedCoins}`}
              >
                <span className="shop-panel__wallet-label">Monedas disponibles</span>
                <div className="shop-panel__wallet-badge" role="presentation">
                  <svg
                    className="shop-panel__wallet-icon"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    aria-hidden="true"
                  >
                    <path d={COIN_ICON_PATH} />
                  </svg>
                  <span className="shop-panel__wallet-value">x {formattedCoins}</span>
                  {coinDiff && (
                    <span
                      key={coinDiff.key}
                      className="shop-panel__wallet-diff"
                      aria-hidden="true"
                    >
                      -{coinDiff.amount}
                      <svg
                        className="shop-panel__wallet-diff-icon"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                      >
                        <path d={COIN_ICON_PATH} />
                      </svg>
                    </span>
                  )}
                </div>
              </div>
            </header>

            <div className="shop-panel__items">
              {SHOP_ITEMS.map((item) => {
                const affordable = coins >= item.price;
                return (
                  <article key={item.id} className="shop-item">
                    <header className="shop-item__header">
                      <h3 className="shop-item__title">{item.name}</h3>
                      <span className="shop-item__price" aria-label={`${item.price} monedas`}>
                        <svg
                          className="shop-item__price-icon"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                          aria-hidden="true"
                        >
                          <path d={COIN_ICON_PATH} />
                        </svg>
                        <span className="shop-item__price-value">x {item.price}</span>
                      </span>
                    </header>
                    <p className="shop-item__description">
                      {item.id === "refresco" && "Bebida helada para refrescar la pista. (+1 x ❤️)"}
                      {item.id === "taco" && "Hecho a mano, perfecto para recargar energía. (+2 x ❤️)"}
                      {item.id === "cemita" && "Esponjosa y rellena al estilo Puebla. (+3 x ❤️)"}
                    </p>
                    <button
                      type="button"
                      className="shop-item__button"
                      disabled={!affordable}
                      onClick={() => handlePurchase(item)}
                    >
                      {affordable ? "Comprar" : "Sin monedas suficientes"}
                    </button>
                  </article>
                );
              })}
            </div>

            {feedback && (
              <div
                className={`shop-panel__feedback shop-panel__feedback--${feedback.type}`}
                role="status"
                aria-live="assertive"
              >
                <span className="shop-panel__feedback-message">{feedback.message}</span>
                {feedback.healAmount > 0 && (
                  <span className="shop-panel__feedback-heal" aria-hidden="true">
                    +{feedback.healAmount}
                    <span className="shop-panel__feedback-heart" role="presentation">❤️</span>
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="shop-panel__aside">
            <button className="shop-panel__close" type="button" onClick={hideShop} aria-label="Cerrar tienda">
              ×
            </button>
            <div className="shop-panel__aside-inner">
              <h4 className="shop-panel__aside-title">Tienda del Milaneso</h4>
              {calacaImage && (
                <img
                  src={calacaImage.src}
                  alt="Calaca bailando"
                  key={calacaImage.src}
                  className="shop-panel__aside-image"
                />
              )}
              <p className="shop-panel__aside-caption">{calacaImage?.caption ?? "Milaneo selecciona gifs premium cada vez que abres la tienda."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
